(function () {
  window.dataLayer = window.dataLayer || [];

  window.gtag =
    window.gtag ||
    function () {
      window.dataLayer.push(arguments);
    };

  function danfeTrack(eventName, params) {
    params = params || {};

    params.page_path = window.location.pathname;
    params.page_title = document.title;

    window.gtag("event", eventName, params);
  }

  /* -------------------------------------
     TRACK ACADEMY LINKS
  ------------------------------------- */

  document.addEventListener("click", function (event) {
    const link = event.target.closest("[data-academy-event]");

    if (!link) return;

    danfeTrack(link.dataset.academyEvent, {
      resource_name:
        link.dataset.resourceName || "",

      source_school:
        link.dataset.sourceSchool || "",

      cta_location:
        link.dataset.ctaLocation || "",

      tea_type:
        link.dataset.teaType || "",

      link_text:
        link.textContent.trim(),

      link_url:
        link.href || ""
    });
  });


  /* -------------------------------------
     AUDIOBOOK START
     Counts first play per page load
  ------------------------------------- */

  document
    .querySelectorAll("[data-academy-audio]")
    .forEach(function (audio) {

      let started = false;

      audio.addEventListener("play", function () {

        if (started) return;

        started = true;

        danfeTrack("academy_audio_start", {
          resource_name:
            audio.dataset.resourceName ||
            "Tea Made Simple Audiobook",

          source_school:
            "Start Here",

          audio_url:
            audio.currentSrc || audio.src
        });
      });

    });

})();